<template>
  <div>
    <div class="over-lay" @click="closePopup"></div>
    <div class="popup">
      <Positive-Vote class="positive-vote" />
      <!-- Connect profile -->
      <div v-if="notConnected" class="hdr">Verify your profile</div>
      <div v-if="notConnected" class="thanks-section">
        to unlock {{ lbCreditsPlan ? credits : views }} remaining contacts
      </div>
      <div v-show="notConnected" class="btn-section d-flex">
        <div>
          <button
            class="but fn-12"
            v-if="!loading"
            @click="connectLinkedin"
            type="button"
          >
            <LinkedIn-Icon class="ln-icon" />Connect your profile
          </button>
          <Spinner v-else />
        </div>
        <span class="skip" v-show="!loading" @click="skip()"
          >skip this step</span
        >
      </div>
      <!-- End of Connect profile -->
      <!-- Connected Successfully-->
      <div v-if="!notConnected" class="hdr">Profile Verified</div>
      <div v-if="!notConnected" class="thanks-section">
        You've unlocked {{ lbCreditsPlan ? credits : views }} contacts!
      </div>
      <div class="btn-section d-flex" v-show="!notConnected">
        <Success-Check-box></Success-Check-box>
        <span class="txt">
          <span class="under-line">{{ userData.fullName }}</span> is connected
          with your Adapt account
        </span>
      </div>
      <!-- End of Connected Successfully-->
    </div>
  </div>
</template>

<script>
import positiveVoteIcon from './../assets/icons/svg/positive-vote.svg'
import linkedInIcon from './../assets/icons/svg/linkedin.svg'
import animatedCHeckBox from './../components/AnimatedCheckbox'
import { post } from './../assets/util/rest.js'
import { MxEvent } from './../assets/util/constants/analytics.js'
import sharedFunctions from './../assets/util/functions.js'
import Spinner from '@/components/Spinner'

export default {
  name: 'Linkedin-Connect-Popup',
  data: function () {
    return {
      notConnected: true,
      loading: false,
      win: null,
    }
  },
  components: {
    'Positive-Vote': positiveVoteIcon,
    'Success-Check-box': animatedCHeckBox,
    'LinkedIn-Icon': linkedInIcon,
    Spinner,
  },
  methods: {
    connectSuccess() {
      sharedFunctions.track(
        MxEvent.connectToLinkedInSuccess,
        {},
        this.$store.state
      )
      this.$emit('success', true)
    },
    connectFailed() {
      sharedFunctions.track(
        MxEvent.connectToLinkedInFail,
        {},
        this.$store.state
      )
      this.$emit('failed', true)
    },
    skip() {
      sharedFunctions.track(
        MxEvent.connectToLinkedInSkip,
        {},
        this.$store.state
      )
      this.$emit('skip', true)
    },
    closePopup() {
      sharedFunctions.track(
        MxEvent.connectToLinkedInClose,
        {},
        this.$store.state
      )
      this.$emit('close', true)
    },
    connectLinkedin() {
      this.loading = true
      sharedFunctions.track(
        MxEvent.connectToLinkedInBtnClicked,
        {},
        this.$store.state
      )
      post('li/profile/connect.htm', this.userData)
        .then((res) => {
          this.loading = false
          if (res && res.status == 200) {
            this.notConnected = false
            const that = this
            setTimeout(function () {
              that.connectSuccess()
            }, 3000)
          } else if (res && res.status == 406) {
            this.connectFailed()
          }
        })
        .catch((e) => {
          this.loading = false
          console.log(e)
        })
    },
  },
  computed: {
    userEmail() {
      return this.$store.state.header.email
    },
    userData() {
      return this.$store.state.liData
    },
    views() {
      return this.$store.state.header.views
    },
    lbCreditsPlan() {
      return this.$store.state.header.lbCreditsPlan
    },
    credits() {
      return this.$store.state.header.credits
    },
  },
  created() {
    sharedFunctions.track(MxEvent.connectToLinkedinShown, {}, this.$store.state)
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.over-lay {
  background: rgb(0, 0, 0, 0.85);
  position: fixed;
  height: 100%;
  top: 0px;
  width: 100%;
  left: 0;
  z-index: 3;
}
.popup {
  position: fixed;
  width: 82%;
  color: #474542;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 23px 0;
  border-radius: 5px;
  background-color: $white;
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 60px;
  .positive-vote {
    width: 60px;
    height: 60px;
    position: absolute;
    top: -35px;
  }
  .hdr {
    font-size: 20px;
    text-align: center;
    font-weight: 500;
    line-height: 0.84;
  }
  .thanks-section,
  .note-section {
    width: 80%;
    text-align: center;
    line-height: 1.25;
    font-size: 14px;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .note-section {
    width: 100%;
    padding: 24px 15%;
    margin-bottom: 17px;

    opacity: 0.85;
    font-size: 14px;
    line-height: 1.53;
    color: $text-dark;
    background-color: #f7f7f7;
    a {
      color: $primary-color;
    }
  }
  .btn-section::v-deep {
    flex-direction: column;
    button {
      width: 160px;
      padding: 10px 0px;
      margin: 5px;
      font-size: 14px;
      border: solid 1px #56a2f9;
      border-radius: 5px;
      background-color: $white;
      color: $primary-color;
      &.btn-blue {
        background-color: $primary-color;
        color: $white;
      }
      .ln-icon {
        width: 16px;
        height: 16px;
        margin-right: 5px;
        vertical-align: bottom;
      }
    }
    .spinner {
      margin: 5px 0;
      height: 38px;
    }
    .cancelBtn {
      color: $primary-color;
    }
    .skip {
      text-align: right;
      font-size: 12px;
      text-decoration: underline;
      color: #787878;
      cursor: pointer;
    }
    .txt {
      padding: 0 15px;
      font-size: 13px;
      line-height: 22px;
      .under-line {
        text-decoration: underline;
        color: $primary-color;
      }
    }
  }
}
</style>
